import { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Container, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';

const WhatsappKeys = (props) => {
  const { modal, setModal } = props;
  const [apiKey, setApiKey] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const onSubmit = async (e) => {
    e.preventDefault();
    let formData;
    formData = {
      apiKey: apiKey,
      secretKey: secretKey
    };

    // try {
    //   const { data } = await Password_Change(formData);
    //   if (data.status === 200) {
    //     toast.success(data.message, {
    //       autoClose: 1000,
    //       transition: Zoom
    //     });
    //     setModal(false);
    //     setPassword('');
    //     setNewPassword('');
    //     setChangePassword('');
    //   } else {
    //     setPassword(password);
    //     setNewPassword(newpassword);
    //     setChangePassword(changePassword);
    //   }
    // } catch (error) {
    //   toast.error(error?.response?.data?.message, {
    //     autoClose: 1000,
    //     transition: Zoom
    //   });
    // }
  };

  return (
    <Modal size="lg" isOpen={modal} toggle={() => setModal(!modal)}>
      <ModalHeader toggle={() => setModal(!modal)}>WhatsApp Keys</ModalHeader>
      <ModalBody>
        <Container fluid={true} className="p-0">
          <Row>
            <Col xs="12">
              <div>
                <div className=" login-tab">
                  <Form className="theme-form" onSubmit={(e) => onSubmit(e)}>
                    <div className="mb-3 ">
                      <Label className="col-form-label">{'Api key'}</Label>
                      <Input
                        className="form-control"
                        type={'text'}
                        onChange={(e) => setApiKey(e.target.value)}
                        defaultValue={apiKey}
                        required="Enter a Valid Password"
                        placeholder="*********"
                      />
                    </div>
                    <div className="mb-3 ">
                      <Label className="col-form-label">{'Secret key'}</Label>
                      <Input
                        className="form-control"
                        type={'text'}
                        onChange={(e) => setSecretKey(e.target.value)}
                        defaultValue={secretKey}
                        required="Enter a Valid Password"
                        placeholder="*********"
                      />
                    </div>
                    <div className="login-btn mb-0">
                      <Button color="primary" type="submit" value="submit">
                        {'Done'}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default WhatsappKeys;
